export default __webpack_public_path__ + "static/media/david12.ff50aae0.jpg";